import * as Sentry from '@sentry/vue';
import type { App } from 'vue';

export const initSentry = (app: App, router) => {
  Sentry.init({
    app,
    dsn: 'https://8ef49fe93a9830fa91bea09246e15491@sentry.h-shgroup.com/4',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  });
};
